'use strict';

require('react');
require('classnames');
require('../Box/Box.js');
require('../../style-inject.es-dcee06b6.js');
require('../Icon/Icon.js');
require('@sendsprint/api-types');
require('./assets/Ca.js');
require('./assets/Gb.js');
require('./assets/Gh.js');
require('./assets/Ke.js');
require('./assets/Ng.js');
require('./assets/Us.js');
require('./assets/Za.js');
require('./assets/None.js');
require('./utils/getFlagSvgByCountryInitials.js');
var components_Flag_Flag = require('./Flag.js');



module.exports = components_Flag_Flag;
